import { render, staticRenderFns } from "./group-label.vue?vue&type=template&id=61c7bfc9&"
import script from "./group-label.vue?vue&type=script&lang=ts&"
export * from "./group-label.vue?vue&type=script&lang=ts&"
import style0 from "./group-label.vue?vue&type=style&index=0&id=61c7bfc9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports